import React from 'react'
import Style from './style'

const LoadingSpinner = ({
	size = 'medium',
	color = 'primary',
	message,
	overlay = false,
	className,
	...props
}) => {
	const SpinnerComponent = (
		<Style.SpinnerContainer className={className} $overlay={overlay} {...props}>
			<Style.Spinner $size={size} $color={color}>
				<Style.SpinnerCircle />
			</Style.Spinner>
			{message && <Style.Message $size={size}>{message}</Style.Message>}
		</Style.SpinnerContainer>
	)

	return SpinnerComponent
}

// Preset sizes for common use cases
LoadingSpinner.Small = (props) => <LoadingSpinner size='small' {...props} />
LoadingSpinner.Medium = (props) => <LoadingSpinner size='medium' {...props} />
LoadingSpinner.Large = (props) => <LoadingSpinner size='large' {...props} />

// Overlay spinner that covers entire screen/container
LoadingSpinner.Overlay = (props) => <LoadingSpinner overlay {...props} />

export default LoadingSpinner
